import { api } from "@/lib/http.ts";

export type UpdateSurfacePreferencesResp = {
  surfacePreferences: Record<string, unknown>;
};

export const updateUserSurfacePreferences = async (
  surface: string,
  preferenceDelta: Record<string, unknown>,
): Promise<UpdateSurfacePreferencesResp> => {
  return (
    await api.post<UpdateSurfacePreferencesResp>(
      `/api/a/users/me/preferences/${surface}`,
      preferenceDelta,
    )
  ).data;
};

/**
 * Parse selected calendar IDs from the preferences string format
 */
export const parseSelectedCalendarIds = (selectedCalendarIdsStr: string): string[] => {
  try {
    return JSON.parse(selectedCalendarIdsStr);
  } catch {
    return [];
  }
};

/**
 * Convert selected calendar IDs to the preferences string format
 */
export const stringifySelectedCalendarIds = (selectedCalendarIds: string[]): string => {
  return JSON.stringify(selectedCalendarIds);
};

/**
 * Parse preferred times from the preferences string format
 */
export const parsePreferredTimes = (preferredTimesStr: string): string[] => {
  try {
    return JSON.parse(preferredTimesStr);
  } catch {
    return [];
  }
};

/**
 * Convert preferred times to the preferences string format
 */
export const stringifyPreferredTimes = (preferredTimes: string[]): string => {
  return JSON.stringify(preferredTimes);
};

/**
 * Parse blocked times from the preferences string format
 */
export const parseBlockedTimes = (blockedTimesStr: string): string[] => {
  try {
    return JSON.parse(blockedTimesStr);
  } catch {
    return [];
  }
};

/**
 * Convert blocked times to the preferences string format
 */
export const stringifyBlockedTimes = (blockedTimes: string[]): string => {
  return JSON.stringify(blockedTimes);
};

/**
 * Parse flexible meeting IDs from the preferences string format
 */
export const parseFlexibleMeetingIds = (str: string): string[] => {
  try {
    return JSON.parse(str);
  } catch {
    return [];
  }
};

/**
 * Convert flexible meeting IDs to the preferences string format
 */
export const stringifyFlexibleMeetingIds = (ids: string[]): string => {
  return JSON.stringify(ids);
};
